import React, { useState } from 'react';
import Layout from './components/Layout';
import Home from './components/Home';
import Blogs from './components/Blogs';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AboutUs from './components/AboutUs';
import LinkQR from './components/LinkQR';
import MenuQR from './components/MenuQR';
import WifiQR from './components/WifiQR';
import VcardQR from './components/VcardQR';

export default function App() {
  const [page, setPage] = useState<string>('home');
  const [selectedBlogSlug, setSelectedBlogSlug] = useState<string | null>(null);

  return (
    <Layout page={page} setPage={setPage}>
      {page === 'home' && (
        <Home setPage={setPage} setSelectedBlogSlug={setSelectedBlogSlug} />
      )}
      {page === 'blogs' && (
        <Blogs selectedSlug={selectedBlogSlug} setSelectedSlug={setSelectedBlogSlug} setPage={setPage} />
      )}
      {page === 'contact' && <Contact />}
      {page === 'privacy' && <PrivacyPolicy />}
      {page === 'terms' && <TermsOfService />}
      {page === 'about' && <AboutUs />}
      {page === 'link-qr' && <LinkQR />}
      {page === 'menu-qr' && <MenuQR />}
      {page === 'wifi-qr' && <WifiQR />}
      {page === 'vcard-qr' && <VcardQR />}
    </Layout>
  );
}
